import { MailboxBindingDialog } from './mailbox-binding-dialog';
import { DIALOG } from '../dialog-combiner';
import { transitions } from '../transition.config';
import { userModals } from 'core/User/modal.config';

DIALOG.add(userModals.MAILBOX_BINDING, {
  component: MailboxBindingDialog,
  transition: transitions.SLIDE_UP,
  anchor: 'portal',
});
